/*!
  * Furillo tag-filters.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
import { extend, getParent } from './helpers.js';
export default class TagFilter {

    constructor(element, options) {

        const defaults = {
            listWrapper: element.nextElementSibling,
            onFiltered: function () { },
            autoInit: true
        };

        this._element = element;
        this._allowMultiple = element.getAttribute('data-filter-allow-multiple') === 'true';
        this._matchAll = element.getAttribute('data-filter-match-all') === 'true';
        this._serverSide = element.getAttribute('data-filter-server-side') === 'true';
        this._options = extend(defaults, options);
        this.activeTags = [];

        if (this._options.autoInit)
            this.init();
    }

    init() {
        const base = this;

        base._element.querySelectorAll('a').forEach(anchor => {

            anchor.addEventListener('click', evt => {

                evt.preventDefault();  
                const hash = evt.target.getAttribute('href');                                                              
                if (evt.target.classList.contains('active')) {                    
                    base.activeTags = base.activeTags.filter(function (item) {
                        return item !== hash;
                    });
                }
                else {

                    if (!base._allowMultiple)
                        base.activeTags = [];

                    base.activeTags.push(hash);
                }

                if (base._serverSide) {
                    let href = window.location.href.replace(window.location.search, '');
                    let query = new URLSearchParams(window.location.search);
                    if (base.activeTags.length === 0 && query.has('tag')) {
                        query.delete('tag');
                    }
                    else {
                        // Iterate the tags and remove '?'.
                        for (let i = 0; i < base.activeTags.length; i++) {
                            if (!base.activeTags[i].startsWith('?'))
                                continue;

                            base.activeTags[i] = base.activeTags[i].substring(1);
                        }

                        query.set('tag', base.getCombinedHash());
                    }

                    // Always remove any pagination
                    if (query.has('p')) {
                        query.delete('p');
                    }

                    // Add query
                    if (query.size > 0) {
                        href += '?' + query.toString().replace('%7C', '|');
                    }

                    // "Redirect"
                    window.location.href = href;
                    return;
                }

                window.history.pushState('', document.title, window.location.pathname + base.getCombinedHash());
                base.filterList();
            });
        });

        window.addEventListener('pageshow', (event) => {
            base.filterList();

            // Expand filters
            if (base.activeTags.length === 0)
                return;

            const button = base._element.querySelector('button[aria-expanded="false"]');
            if (button) {
                button.setAttribute('aria-expanded', true);
                button.classList.remove('collapsed');

                base._element.querySelector('div.collapse').classList.add('show');
            }
        });

        //if (this._options.autoInit) {
        //    window.addEventListener('pageshow', (event) => {
        //        base.filterList();
        //    });
        //}
        //else {
        //    base.filterList();
        //}
    }

    getCombinedHash() {
        const base = this;

        if (base.activeTags.length === 0)
            return '';

        if (base.activeTags.length === 1)
            return base.activeTags[0];

        return base.activeTags.join('|');
    }

    filterList() {
        const base = this;

        // If no tags active, check in the url
        if (base.activeTags.length == 0) {

            if (!base._serverSide) {
                var hash = decodeURIComponent(window.location.hash);
                if (hash && hash.length > 0) {
                    var items = hash.split('|');
                    for (var i = 0; i < items.length; i++) {
                        base.activeTags.push(items[i]);
                    }
                }
            } else {
                let query = new URLSearchParams(window.location.search);
                if (query.size > 0 && query.has('tag')) {
                    var items = query.get('tag').split('|');
                    for (var i = 0; i < items.length; i++) {
                        base.activeTags.push('?' + items[i]);
                    }
                }
            }
        }

        // Manage filter buttons
        base._element.querySelectorAll('a').forEach(anchor => {
            anchor.classList.remove('active');

            for (var i = 0; i < base.activeTags.length; i++) {
                if (anchor.getAttribute('href') === base.activeTags[i])
                    anchor.classList.add('active');
            }
        });
                
        // Clear filters
        if (base.activeTags.length === 0) {
            base._options.listWrapper.querySelectorAll('*[data-tags]').forEach(element => {

                let item = getParent(element, '.umb-block-grid__layout-item');
                if (!item)
                    item = element;

                item.classList.remove('d-none');
            });
            base._options.onFiltered();
            return;
        }

        if (base._serverSide)
            return;

        // Filter
        base._options.listWrapper.querySelectorAll('*[data-tags]').forEach(element => {

            let item = getParent(element, '.umb-block-grid__layout-item');
            if (!item)
                item = element;
            
            item.classList.add('d-none');

            let visible = false;
            for (var i = 0; i < base.activeTags.length; i++) {
                let tag = base.activeTags[i].replace('#', '');

                if (element.getAttribute('data-tags').indexOf(tag) > -1) {
                    visible = true;

                    if (!base._matchAll)
                        break;
                } else if (base._matchAll) {
                    visible = false;
                    break;
                }
            }

            if (visible === true) {
                item.classList.remove('d-none');
            }
        });

        base._options.onFiltered();
    }
};